class BranchSegmentForm {
    constructor(formID, branchID, branchSegmentUuid = null) {
        this.form = document.getElementById(formID);
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.branchID = branchID;
        this.branchSegmentUuid = branchSegmentUuid;

        if(this.form){
            this.modal = this.form.querySelector('.modal');
            this.initFormValidation();
            this.backToBranchSegments();
        }
    }
    backToBranchSegments(){
        const thisClass = this;
        this.form.querySelectorAll('.back-to-branch-segments').forEach((e) => {
            e.addEventListener('click', function () {
                bootstrap.Modal.getInstance(thisClass.modal).hide();
                new bootstrap.Modal(document.getElementById('branch_segments_modal'), {}).show();
            });
        });
    }
    initFormValidation(){
        const thisClass = this;

        let submitButton = this.form.querySelector('button[data-type="submit"]');

        function isValidIP(ip) {
            const regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
            return regex.test(ip);
        }

        function isValidRange(range) {
            const rangeRegex = /^((25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})\.){3}(25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})\s?-\s?((25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})\.){3}(25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})$/;
            if(rangeRegex.test(range)){
                const {start, end} = parseRange(range);
                if (start === end) {
                    return {
                        valid: false,
                        message: 'Invalid subnet / IP range'
                    };
                }
                if (ipToInt(start) > ipToInt(end)) {
                    return {
                        valid: false,
                        message: 'The first IP of the range must be lower than the last'
                    };
                }
                return {
                    valid: true
                };
            }
            return {
                valid: false
            };
        }

        function isValidSubnet(subnet) {
            if (subnet.includes('/')) {
                const parts = subnet.split('/');
                if (isValidIP(parts[0])) {
                    if (parts[1] && Number(parts[1]) >= 0 && Number(parts[1]) <= 32) {
                        return {
                            valid: true
                        };
                    }
                    return {
                        valid: false,
                        message: 'Invalid subnet'
                    };
                }
                return {
                    valid: false,
                    message: 'Invalid IP'
                };
            }
            return {
                valid: false
            };
        }

        function parseRange(range) {
            const parts = range.split('-');
            return { start: parts[0].trim(), end: parts[1].trim() };
        }

        function ipToInt(ip) {
            return ip.split('.').reduce((acc, octet) => (acc << 8) + parseInt(octet), 0);
        }

        let validator = FormValidation.formValidation(
            this.form,
            {
                fields: {
                    'name': {
                        validators: {
                            notEmpty: {
                                message: 'This field is required'
                            },
                            stringLength: {
                                max: 64,
                                message: 'Name cannot be over 64 characters',
                            }
                        },
                    },
                    'subnet_range': {
                        validators: {
                            notEmpty: {
                                message: 'This field is required'
                            },
                            callback: {
                                message: 'Enter the Subnet (x.x.x.x/xx) or IP Range (x.x.x.x - x.x.x.x)',
                                callback: function (input) {
                                    const rangeValidResult = isValidRange(input.value);
                                    const subnetRangeResult = isValidSubnet(input.value);

                                    if(rangeValidResult.valid || subnetRangeResult.valid){
                                        return new Promise((resolve) => {
                                            fetch('/branches?do=validateSubnetRange&organizationID=' + thisClass.organizationID +
                                                '&branchID=' + thisClass.branchID +
                                                '&subnetRange=' + input.value +
                                                (thisClass.branchSegmentUuid ? '&branchSegmentID=' + thisClass.branchSegmentUuid : ''))
                                                .then(response => {
                                                    if (!response.ok) {
                                                        return resolve({
                                                            valid: false,
                                                            message: 'Invalid subnet / IP range'
                                                        });
                                                    }
                                                    return response.json().then(data => resolve(data));
                                                })
                                                .catch(() => {
                                                    resolve({
                                                        valid: false,
                                                        message: 'Invalid subnet / IP range'
                                                    });
                                                });
                                        });
                                    }

                                    if(rangeValidResult.message){
                                        return rangeValidResult;
                                    }
                                    if(subnetRangeResult.message){
                                        return subnetRangeResult;
                                    }

                                    return {
                                        valid: false,
                                        message: 'Invalid subnet / IP range'
                                    }
                                }
                            },
                        },
                    },
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger({
                        delay: {
                            subnet_range: 0.5
                        },
                    }),
                    autoFocus: new FormValidation.plugins.AutoFocus(),
                    submitButton: new FormValidation.plugins.SubmitButton(),
                    // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                    bootstrap: new FormValidation.plugins.Bootstrap5({
                        rowSelector: '.fv-row',
                        eleInvalidClass: '',
                        eleValidClass: ''
                    }),
                }
            }
        );

        submitButton.addEventListener('click', function (e) {
            // Prevent default button action
            e.preventDefault();
            validator.validate().then(function(status) {
                if(status === 'Valid'){
                    new DismissModal(thisClass.modal.id).disable();
                    // Show loading indication
                    submitButton.setAttribute('data-kt-indicator', 'on');
                    // Disable button to avoid multiple click
                    submitButton.disabled = true;
                    $(thisClass.form).submit();
                }
            });
        });

        let context = $.nette.ext(thisClass.form.id);
        if(!context){
            $.nette.ext(thisClass.form.id, {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if(formID === thisClass.form.id){
                        thisClass.modal = document.getElementById(thisClass.modal.id);

                        if(payload.success){
                            toastr.success(payload.message);
                        } else {
                            toastr.error(payload.message);
                        }

                        new DismissModal(thisClass.modal.id).enable();
                        bootstrap.Modal.getInstance(thisClass.modal).hide();
                        bootstrap.Modal.getOrCreateInstance(document.getElementById('branch_segments_modal')).show();

                        let branchSegmentsDatatable = $('#branch-segments-datatable').DataTable();
                        branchSegmentsDatatable.ajax.reload(null, false);

                        let branchDatatable = $('#branch-datatable');
                        if(branchDatatable){
                            branchDatatable.DataTable().ajax.reload(null, false);
                        }

                        // Clear form
                        thisClass.modal.querySelector('input[name="name"]').value = '';
                        thisClass.modal.querySelector('input[name="subnet_range"]').value = '';

                        // Cancel loading indication
                        let submitButton = thisClass.modal.querySelector('button[data-type="submit"]');
                        submitButton.setAttribute('data-kt-indicator', 'off');
                        submitButton.disabled = false;
                    }
                }
            });
        }
        $.nette.load();
    }
}
window.BranchSegmentForm = BranchSegmentForm;